import { useEffect, useRef, useState } from "react";
import { ToastContainer } from "./styles";
import SVG from "react-inlinesvg";
import { useWebSocket } from "../SocketHost/WebSocketProvider";
export default function BillingToast({ showCreditsUsedToast }) {
  const [toastQueue, setToastQueue] = useState([]);
  const toastTimeout = useRef(null);

  const { registerHandler, unregisterHandler } = useWebSocket();

  useEffect(() => {
    registerHandler("creditsConsumed", (msg) => {
      const amount = Math.abs(msg.payload);
      setToastQueue((prevQueue) => [...prevQueue, amount.toString()]);
    });
    return () => {
      unregisterHandler("creditsConsumed");
    };
  }, [registerHandler, unregisterHandler]);

  useEffect(() => {
    if (toastQueue.length > 0) {
      toastTimeout.current = setTimeout(() => {
        setToastQueue((prevQueue) => prevQueue.slice(1));
      }, 3000);
    }
    return () => {
      clearTimeout(toastTimeout.current);
    };
  }, [toastQueue]);

  return (
    <ToastContainer>
      {showCreditsUsedToast && toastQueue[0] && (
        <div
          key={Math.random()} // just to force a re-render when the toast changes
          className="billingToast"
        >
          {toastQueue[0]}
          <SVG src="/assets/pricing/credits.svg" />
        </div>
      )}
    </ToastContainer>
  );
}
